import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AppNavbar: React.FC = () => {
  const { isAuthenticated, logout, status, isAdmin } = useAuth();
  const hasAccess = isAuthenticated || status === 'pending';

  return (
    <nav className="navbar navbar-expand-lg navbar-dark border-bottom">
      <div className="container">
        <NavLink to="/" className="navbar-brand d-flex align-items-center gap-2 gap-md-3">
          <img
            src="/theme/logo.jpeg"
            alt="Sports Zone Bangladesh logo"
            className="rounded brand-logo"
          />
          <div className="d-flex flex-column">
            <span className="brand-title">Sports Zone</span>
            <span className="brand-subtitle">BANGLADESH</span>
          </div>
        </NavLink>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#main-nav"
          aria-controls="main-nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="main-nav">
          <div className="navbar-nav ms-auto align-items-lg-center gap-lg-2">
            <NavLink to="/" className="nav-link">
              Home
            </NavLink>
            <NavLink to="/about" className="nav-link">
              About
            </NavLink>
            <NavLink to="/#services" className="nav-link">
              Services
            </NavLink>
            <NavLink to="/events" className="nav-link">
              Events
            </NavLink>
            <NavLink to="/gallery" className="nav-link">
              Gallery
            </NavLink>
            <NavLink to="/players" className="nav-link">
              Players
            </NavLink>
            <NavLink to="/contact-us" className="nav-link">
              Contact Us
            </NavLink>
            {hasAccess ? (
              <>
                <NavLink to="/dashboard" className="nav-link">
                  Dashboard
                </NavLink>
                {!isAdmin && (
                  <div className="nav-item dropdown">
                    <button
                      className="nav-link dropdown-toggle"
                      type="button"
                      id="settingsDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="bi bi-gear me-1"></i>
                      Settings
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="settingsDropdown">
                      <li>
                        <NavLink to="/dashboard/change-password" className="dropdown-item">
                          <i className="bi bi-key me-2"></i>
                          Change Password
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/dashboard/profile/edit" className="dropdown-item">
                          <i className="bi bi-person-gear me-2"></i>
                          Edit Profile
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                )}
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm ms-lg-2"
                  onClick={logout}
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <NavLink to="/auth" className="btn btn-outline-secondary btn-sm ms-lg-2">
                  Login
                </NavLink>
                <NavLink to="/register" className="btn btn-arena btn-sm ms-lg-2">
                  Register
                </NavLink>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AppNavbar;
